module.exports = __webpack_public_path__ + "img/86400.5d12cee2.jpg";